export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-jornada-bloqueio' */ '@/views/ambulatorio/jornada-bloqueio/Index'),
        path: 'jornada-bloqueio',
        redirect: 'jornada-bloqueio/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada-bloqueio' */'@/views/ambulatorio/jornada-bloqueio/List.vue'),
                name: 'ambulatorio-jornada-bloqueio-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada-bloqueio' */ '@/views/ambulatorio/jornada-bloqueio/Form.vue'),
                name: 'ambulatorio-jornada-bloqueio-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada-bloqueio' */ '@/views/ambulatorio/jornada-bloqueio/Form.vue'),
                name: 'ambulatorio-jornada-bloqueio-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]